export const HOW_GET_DEAL = [
  {
    id: 1,
    title: 'Найдите покупателя',
    descr: 'Обсудите с ним условия получения скидки на ипотеку',
    list: [
      'При продаже объекта вы готовы снизить цену на 3,4%, чтобы покупатель получил скидку 4% к ставке на ипотеку',
    ],
    imageClass: 'phone',
  },
  {
    id: 2,
    title: 'Отправьте покупателю ссылку',
    descr: 'Нажмите на кнопку в карточке объекта и отправьте ему ссылку удобным для вас способом',
    list: [
      'Покупатель заполнит анкету и подаст заявку на ипотеку',
      'Когда он получит одобрение от банка — можно проводить сделку',
    ],
    imageClass: 'send-link',
  },
];
